import { PanelHelp } from "@/components/PanelHelp";
import type { RuntimeChangeState } from "@/hooks/useRuntimeChange";
import { t } from "@/i18n";
import { MAX_REASON, reasonValid } from "@/lib/runtimeChange";

// The reason every «Betrieb» change carries. What a change says shows in
// RuntimeNotice, wherever on the page it was made.
export function ReasonCard({ change }: { change: RuntimeChangeState }) {
  const { reason, setReason } = change;
  return (
    <section class="card">
      <h2>{t("ops.reason")}</h2>
      <PanelHelp k="ops.reason" />
      <input
        class="ops-reason"
        type="text"
        maxLength={MAX_REASON}
        value={reason}
        placeholder={t("ops.reason.placeholder")}
        aria-label={t("ops.reason")}
        onInput={(e) => setReason((e.target as HTMLInputElement).value)}
      />
      {!reasonValid(reason) && <div class="kpi-sub">{t("ops.reason.missing")}</div>}
    </section>
  );
}
